import * as actionTypes from "../actions/actionTypes";

const initialState = {
  approvalListCount: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_APPROVAL_LIST_COUNT:
      return {
        ...state,
        approvalListCount: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
